import {Pipe, PipeTransform} from '@angular/core';
import { Level, Zone } from '@app/graphql-typings/graphql';
import { LevelZoneService } from '@app/layout/sites/manage/manage-sites/upsert-site/forms/level-zone-form/level-zone.service';

export enum LevelZoneMode {LEVEL, ZONES, DEFAULT};

/*
  PASSED | DISPLAY
  ================

  default mode:
  Level  | <Level Name>
  Zone   | <Level Name>, <Zone Name>
  Zone[] | <Level Name>: <Zone Name 1>, <Zone Name 2>

  level mode:
  Level  | <Level Name>
  Zone   | <Level Name>
  Zone[] | <Level Name>

  zone mode:
  Level  | nothing
  Zone   | <Zone Name>
  Zone[] | <Zone Name 1>, <Zone Name 2>
*/

@Pipe({
  name: 'levelZone',
  standalone: false
})
export class LevelZonePipe implements PipeTransform {

  constructor(private levelZoneService: LevelZoneService) {}

  transform(levelOrZones: Level | Zone | Zone[], mode: LevelZoneMode = LevelZoneMode.DEFAULT): string {
    if (!levelOrZones) {
      return '';
    }

    switch(mode) {
      case LevelZoneMode.DEFAULT:
        return this.levelZoneService.isLevel(levelOrZones) ? levelOrZones.level_name
          : this.getLevelName(levelOrZones) + (Array.isArray(levelOrZones) ? ': ' : ', ') + this.getZoneNames(levelOrZones);

      case LevelZoneMode.LEVEL:
        return this.getLevelName(levelOrZones);
      case LevelZoneMode.ZONES:
        return this.getZoneNames(levelOrZones);
      default:
        throw new Error('Invalid value for LevelZonePipe type: ' + mode);
    }
  }

  private getLevelName(levelOrZones: Level | Zone | Zone[]): string {
    let levelName = '';
    if (this.levelZoneService.isLevel(levelOrZones)) {
      levelName = levelOrZones.level_name;
    } else {
      if (Array.isArray(levelOrZones)) {
        levelName = levelOrZones[0].level ? levelOrZones[0].level.level_name : '';
      } else {
        levelName = levelOrZones.level ? levelOrZones.level.level_name : '';
      }
    }
    return levelName;
  }

  private getZoneNames(levelOrZones: Level | Zone | Zone[]): string {
    let zoneNames = '';
    if (this.levelZoneService.isLevel(levelOrZones)) {
      zoneNames = '';
    } else {
      if (Array.isArray(levelOrZones)) {
        zoneNames = levelOrZones && levelOrZones.length ? levelOrZones.reduce((acc: string[], cur: Zone) => {
          if (cur.zone_name && cur.zone_name.zone_name) {
            acc.push(cur.zone_name.zone_name);
          }
          return acc;
        }, []).join(', ') : '';
      } else {
        zoneNames = levelOrZones.zone_name ? levelOrZones.zone_name.zone_name : '';
      }
    }
    return zoneNames;
  }

}
